import { get } from '../../utils/Cookie';
import { authApi, createParams } from './index';

export const getContentsList = async (request) => {
	try {
		const { searchTags, paging = 2, ...rest } = request;
		const params = createParams(rest);
		// paging3일 때는 searchTags를 처리하지 않음
		if (searchTags && paging !== 3) {
			searchTags.forEach((tag) => {
				if (tag) {
					params.append('searchTags', tag); // 각 태그를 별도로 추가
				}
				if (
					// 달콤아트
					tag === '39' ||
					// 영어야 놀자
					tag === '41' ||
					// 영어동화
					tag === '47' ||
					// 클래식감상
					tag === '143' ||
					// 동물상식
					tag === '5' ||
					// 안전교육
					tag === '36' ||
					// 한국사
					tag === '48'
				) {
					params.append('searchOp', 'title');
				}
				// 달콤아트만
				// if (
				// 	tag === '39' ||
				// 	tag === '41' ||
				// 	tag === '47' ||
				// 	tag === '143' ||
				// 	tag === '5' ||
				// 	tag === '36' ||
				// 	tag === '48'
				// ) {
				// 	params.append('searchOp', 'title');
				// }
			});
		}
		// if (request.params.bookMark) {
		// 	params.append('bookmarked', request.params.bookMark);
		// }
		const url = `/contents/paging${paging}`;
		const title = params.get('searchTitle');

		// 제목에 특수문자가 있으면 제거하고 다시 설정
		if (title) {
			const cleanTitle = title.replace(/[^\w\s가-힣.]/g, ''); // 온점(.)만 남기고 나머지 특수문자 제거
			if (cleanTitle !== title) {
				params.set('searchTitle', cleanTitle);
			}
		}

		const tags = params.get('searchTags');
		if (!title && !tags && paging !== 3) return;
		const { data } = await authApi.get(url, { params }); // URL을 사용하여 요청
		const userId = get('id');
		const resultContent = data?.content?.filter((c) => {
			const isValid = c.createMemberId === 1 || c.createMemberId == userId;
			if (!isValid) {
				return false;
			} else {
				return true;
			}
		});
		const result = { ...data, content: resultContent };
		return result;
	} catch (error) {
		console.error(error);
	}
};

export const getRandomPage = async (request) => {
	try {
		const data = await getContentsList(request);
		const maxPage = data?.totalPages;
		const randomPage = Math.floor(Math.random() * maxPage);
		request.page = randomPage;

		const randomData = await getContentsList(request);
		return randomData;
	} catch (error) {
		console.error(error);
	}
};

export const getContentsListAll = async () => {
	try {
		const { data } = await authApi.get('/contents');
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const getContents = async (uuid) => {
	try {
		const params = createParams({ uuid });
		const { data } = await authApi.get('/contents/json', { params });
		return data;
	} catch (error) {
		console.error(error);
	}
};

export const getBackground = async (uuid) => {
	try {
		const params = createParams({ uuid });
		const { data } = await authApi.get(
			`/contents/background/uuid?uuid=${uuid}`,
		);

		return { ...data };
	} catch (error) {
		return null;
	}
};

export const getContentAttaches = async (contentUuid) => {
	try {
		const params = createParams({ contentUuid });
		const { data } = await authApi.get('/contents/attachment/content-uuid', {
			params,
		});
		return data;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const contentsStart = async (request) => {
	try {
		const { data } = await authApi.post('/contents/start', { ...request });
		return data;
	} catch (error) {
		return null;
	}
};

export const contentsStop = async (request) => {
	try {
		const { data } = await authApi.post('/contents/stop', { ...request });
		return data;
	} catch (error) {
		return null;
	}
};

export const getContentAutocomplete = async (search, limit = 10) => {
	try {
		const params = createParams({
			search: search,
			limit: limit,
		});

		const url = '/contents/autocomplete';

		const { data } = await authApi.get(url, { params });

		return data;
	} catch (error) {
		console.error('❌ 자동완성 API 에러:', error);
		throw error;
	}
};
